import { render, staticRenderFns } from "./AreasViewer.vue?vue&type=template&id=e151f808"
import script from "./AreasViewer.vue?vue&type=script&lang=js"
export * from "./AreasViewer.vue?vue&type=script&lang=js"
import style0 from "./AreasViewer.vue?vue&type=style&index=0&id=e151f808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports